import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { copy, type Copy, type Lang } from '../data/copy';
type LanguageContextValue = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Copy;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('en');
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo<LanguageContextValue>(() => ({
    lang,
    setLang,
    t: copy[lang]
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-230" data-mp="136p0ve64tpmz">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}